module.exports = __webpack_public_path__ + "img/left-arrow.fcef79a0.svg";